// extracted by mini-css-extract-plugin
export default {"container":"De1MzN","legacyLists":"yv03pP","stacked":"nIrkeO"};